// src/pages/admin/CMSDashboardPage.js
import React, { useEffect, useState } from "react";
import { Container, Typography, Grid, Paper, Button, Box } from "@mui/material";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../../firebase";
import { Link } from "react-router-dom";

const CMSDashboardPage = () => {
  const [seriesList, setSeriesList] = useState([]);
  const [episodesList, setEpisodesList] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        const seriesSnapshot = await getDocs(collection(db, "series"));
        const seriesData = seriesSnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        const episodesSnapshot = await getDocs(collection(db, "episodes"));
        const episodesData = episodesSnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        setSeriesList(seriesData);
        setEpisodesList(episodesData);
        console.log("episodesData: ", episodesData);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching dashboard data:", error);
      }
    };

    fetchDashboardData();
  }, []);

  if (loading) {
    return (
      <Container sx={{ mt: 4 }}>
        <Typography variant="h6">Loading dashboard data...</Typography>
      </Container>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ mt: 4 }}>
      <Typography variant="h4" gutterBottom>
        CMS Dashboard
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Paper elevation={3} sx={{ p: 2 }}>
            <Typography variant="h6">Series</Typography>
            <Typography variant="body1">
              Total Series: {seriesList.length}
            </Typography>
            {seriesList.slice(0, 5).map((series) => (
              <Box
                key={series.id}
                sx={{
                  mt: 1,
                  p: 1,
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Box>
                  <Typography variant="subtitle1">
                    {series.seriesTitle}
                  </Typography>
                  <Typography variant="body2">{series.description}</Typography>
                </Box>
                <Button
                  component={Link}
                  to={`/admin/cms/series/edit/${series.id}`}
                  variant="outlined"
                  size="small"
                  sx={(theme) => ({
                    backgroundColor: theme.colors.white,
                    color: theme.colors.blue,
                    border: `1px solid ${theme.colors.blue}`,
                    borderRadius: "50px",
                    padding: "6px 20px",
                    marginBottom: "10px",
                    fontSize: "1rem",
                    textTransform: "none",
                    boxShadow: "none",
                    "&:hover": {
                      boxShadow: "none",
                    },
                  })}
                >
                  Edit
                </Button>
              </Box>
            ))}
            <Button
              component={Link}
              to="/admin/cms/series/new"
              variant="contained"
              color="primary"
              sx={(theme) => ({
                backgroundColor: theme.colors.blue,
                color: theme.colors.white,
                border: `1px solid ${theme.colors.blue}`,
                borderRadius: "50px",
                padding: "6px 20px",
                marginBottom: "10px",
                fontSize: "1rem",
                textTransform: "none",
                boxShadow: "none",
                mt: 2,
                "&:hover": {
                  boxShadow: "none",
                },
              })}
            >
              Create New Series
            </Button>
          </Paper>
        </Grid>
        <Grid item xs={12} md={6}>
          <Paper elevation={3} sx={{ p: 2 }}>
            <Typography variant="h6">Episodes</Typography>
            <Typography variant="body1">
              Total Episodes: {episodesList.length}
            </Typography>
            {episodesList.slice(0, 5).map((episode) => (
              <Box
                key={episode.id}
                sx={{
                  mt: 1,
                  p: 1,
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Box>
                  <Typography variant="subtitle1">{episode.title}</Typography>
                  <Typography variant="body2">{episode.description}</Typography>
                </Box>
                <Button
                  component={Link}
                  to={`/admin/cms/episodes/edit/${episode.id}`}
                  variant="outlined"
                  size="small"
                  sx={(theme) => ({
                    backgroundColor: theme.colors.white,
                    color: theme.colors.blue,
                    border: `1px solid ${theme.colors.blue}`,
                    borderRadius: "50px",
                    padding: "6px 20px",
                    marginBottom: "10px",
                    fontSize: "1rem",
                    textTransform: "none",
                    boxShadow: "none",
                    mt: 2,
                    "&:hover": {
                      boxShadow: "none",
                    },
                  })}
                >
                  Edit
                </Button>
              </Box>
            ))}
            <Button
              component={Link}
              to="/admin/cms/episodes/new"
              variant="contained"
              color="primary"
              sx={(theme) => ({
                backgroundColor: theme.colors.blue,
                color: theme.colors.white,
                border: `1px solid ${theme.colors.blue}`,
                borderRadius: "50px",
                padding: "6px 20px",
                marginBottom: "10px",
                fontSize: "1rem",
                textTransform: "none",
                boxShadow: "none",
                mt: 2,
                "&:hover": {
                  boxShadow: "none",
                },
              })}
            >
              Create New Episode
            </Button>
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
};

export default CMSDashboardPage;
